import { Route } from 'react-router-dom';
import ReactGA from 'react-ga4';

import InvestorDashboard from '~/features/dashboards/InvestorDashboard/InvestorDashboard';
import InstallerDashboard from '~/features/dashboards/InstallerDashboard/InstallerDashboard';
import AdminDashboard from '~/features/dashboards/AdminDashboard/AdminDashboard';
import { useUserContext } from '~/hooks';

function Dashboard() {
  const { loggedInUser } = useUserContext();
  ReactGA.send({
    hitType: 'pageview',
    page: '/dashboard',
    title: 'Dashboard | Conductor Solar'
  });
  document.title = 'Dashboard | Conductor Solar';

  return (
    <Route path="/dashboard">
      {loggedInUser?.isInvestor &&
        <InvestorDashboard />
      }
      {loggedInUser?.isInstaller &&
        <InstallerDashboard />
      }
      {loggedInUser?.isAdmin &&
        <AdminDashboard />
      }

    </Route>
  );
}

export default Dashboard;